import { type MainNavigationMenuItem as MainNavigationMenuItemType } from "components/MainNavigation/types";
import { type MainNavigationTransition } from "components/MainNavigation/hooks/useFadeTransition";
import useMainNavigationActiveStates from "components/MainNavigation/hooks/useActiveStates";
import useMainNavigationStore from "components/MainNavigation/stores/useMainNavigationStore";
import { TooltipModalReferenceProps } from "ds/components/TooltipModal/types";

import MainNavigationBaseActionLink from "../../atoms/BaseAction/Link";
import MainNavigationCounter from "../../atoms/Counter";

type MainNavigationMenuItemProps = {
  item: MainNavigationMenuItemType;
  tooltipModalRef?: TooltipModalReferenceProps["ref"];
} & MainNavigationTransition;

const MainNavigationMenuItem = ({
  item,
  transitionClasses,
  tooltipModalRef,
}: MainNavigationMenuItemProps) => {
  const { activeMenuItemId } = useMainNavigationActiveStates();
  const itemCounts = useMainNavigationStore((state) => state.itemCounts);
  const isActive = item.id === activeMenuItemId;
  const itemCount = itemCounts[item.id] || 0;

  return (
    <MainNavigationBaseActionLink
      id={item.htmlId}
      to={item.to}
      href={item.href}
      onClick={item.onAction}
      title={item.title}
      icon={item.icon}
      isActive={isActive}
      transitionClasses={transitionClasses}
      tooltipModalRef={tooltipModalRef}
    >
      <MainNavigationCounter count={itemCount} inversed={isActive} className={transitionClasses} />
    </MainNavigationBaseActionLink>
  );
};

export default MainNavigationMenuItem;
